import {DataSourceConfig} from './data-source-config.model';
import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

export class LTIConfig extends DataSourceConfig {
    clientSecret: string = null; // for 1.1
    ltiType: string = null;  // for 1.1/1.3
    applicationGuid: string = null;  // for 1.1/1.3
    getLTICredentialsError: boolean;  // for 1.1/1.3
    useGranularGradeSync: boolean;  // for 1.3
    autoCreateLineItems: boolean;  // for 1.3
    multipleLMSShells: boolean;  // for 1.1, 1.3, 1.3 Granular deeplink
    incrementalExport: boolean; // for 1.3
    exportAdditionalAttributes: boolean; // for 1.3

    constructor(
        public baseUrl: string = '', // for 1.1
        public clientId: string = '',  // for 1.1/1.3
        public issuer: string = '', // for 1.3
        public deploymentId: string = '', // for 1.3
        public keySetUrl: string = '', // for 1.3
        public oauth2AccessTokenUrl: string = '', // for 1.3
        public oidcAuthUrl: string = '', // for 1.3
        public ltiVersion: '1.1' | '1.3' = '1.3', // 1.1 / 1.3
        friendlyName: string = ''
    ) {
        super(<DefaultSchemaName>'', friendlyName);
        this.dataSourceType = DataSourceType.LTI;
    }
}

export enum LTI_CONFIG_VERSION {
    'v.1.1' = '1.1',
    'v.1.3' = '1.3'
}
